import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "../../Styles/anneffect.css";
import "../../Styles/resource.css"; // new CSS for pagination/cards

const Resources = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 6;

  // API base URL
  const API_BASE = "/ann/ann-ai-cms/public/";

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${API_BASE}api/content/resources`);
        const data = await res.json();
        if (data?.content) {
          setBlogs(data.content);
        }
      } catch (err) {
        console.error("Error fetching blogs:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const totalPages = Math.ceil(blogs.length / cardsPerPage);
  const currentCards = blogs.slice(
    (currentPage - 1) * cardsPerPage,
    currentPage * cardsPerPage
  );

  if (loading) {
    return <div className="resouces-main-app-container">Loading...</div>;
  }

  return (
    <div className="resouces-main-app-container">
      <div className="ann-effect-banner">
        <div className="width-wrapper">
          <div className="ann-wrapper">
            <h1>Resources</h1>
            <h3>Insights & Innovations</h3>
            <p>
              Stay updated with the latest trends, AI-driven hiring strategies,
              and expert insights in recruitment.
            </p>
          </div>
        </div>
      </div>

      <div className="width-wrapper-2">
        <div className="cards-grid">
          {currentCards.map((card, idx) => (
            <div className="blog-card" key={idx}>
              <img
                src={`${API_BASE}${card.content_image}`}
                alt={card.content_title}
              />
              <h3>{card.content_title}</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: card.content_text,
                }}
              />
              <button
                className="read-more-btn"
                onClick={() => {
                  navigate(`/resources/${card.id}`); // ✅ Correct ID
                  window.scrollTo(0, 0);
                }}
              >
                Read More →
              </button>
            </div>
          ))}
        </div>

        <br />
        <div className="pagination">
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`page-btn ${currentPage === idx + 1 ? "active" : ""}`}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;
